import axios from '../../../../shared/axios';
import { KeyValuePair } from '../../../../shared/models';
import { AppDispatch } from '../../../../store';
import { GetUserActivityEventsRequest, UserActivityEvent } from '../../models';
import * as actionTypes from '../constants/actionTypes';

const getUserActivityEventsStart = () => {
  return {
    type: actionTypes.USER_ACTIVITY_EVENTS_GET_USER_ACTIVITY_EVENTS_START,
  };
};

const getUserActivityEventsSuccess = (data: UserActivityEvent[]) => {
  return {
    type: actionTypes.USER_ACTIVITY_EVENTS_GET_USER_ACTIVITY_EVENTS_SUCCESS,
    data: data,
  };
};

const getUserActivityEventsFail = (error: any) => {
  return {
    type: actionTypes.USER_ACTIVITY_EVENTS_GET_USER_ACTIVITY_EVENTS_FAIL,
    error: error,
  };
};

export const getUserActivityEvents = (params: GetUserActivityEventsRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<UserActivityEvent[]>((resolve, reject) => {
      dispatch(getUserActivityEventsStart());
      const url = `/user-activity-events/get-events`;

      axios
        .post<UserActivityEvent[]>(url, params)
        .then((response) => {
          dispatch(getUserActivityEventsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getUserActivityEventsFail(err));
          reject(err);
        });
    });
  };
};

const getHumanReadableEventTypesStart = () => {
  return {
    type: actionTypes.USER_ACTIVITY_EVENTS_GET_HUMAN_READABLE_EVENT_TYPES_START,
  };
};

const getHumanReadableEventTypesSuccess = (data: KeyValuePair[]) => {
  return {
    type: actionTypes.USER_ACTIVITY_EVENTS_GET_HUMAN_READABLE_EVENT_TYPES_SUCCESS,
    data: data,
  };
};

const getHumanReadableEventTypesFail = (error: any) => {
  return {
    type: actionTypes.USER_ACTIVITY_EVENTS_GET_HUMAN_READABLE_EVENT_TYPES_FAIL,
    error: error,
  };
};

export const getHumanReadableEventTypes = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<KeyValuePair[]>((resolve, reject) => {
      dispatch(getHumanReadableEventTypesStart());
      const url = `/user-activity-events/get-human-event-types`;

      axios
        .get<KeyValuePair[]>(url)
        .then((response) => {
          dispatch(getHumanReadableEventTypesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getHumanReadableEventTypesFail(err));
          reject(err);
        });
    });
  };
};

const getUserTimeZoneStart = () => {
  return {
    type: actionTypes.USER_ACTIVITY_EVENTS_GET_USER_TIME_ZONE_START,
  };
};

const getUserTimeZoneSuccess = (data: string) => {
  return {
    type: actionTypes.USER_ACTIVITY_EVENTS_GET_USER_TIME_ZONE_SUCCESS,
    data: data,
  };
};

const getUserTimeZoneFail = (error: any) => {
  return {
    type: actionTypes.USER_ACTIVITY_EVENTS_GET_USER_TIME_ZONE_FAIL,
    error: error,
  };
};

export const getUserTimeZone = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<string>((resolve, reject) => {
      dispatch(getUserTimeZoneStart());
      const url = `/user-activity-events/get-user-timezone`;

      axios
        .get<string>(url)
        .then((response) => {
          dispatch(getUserTimeZoneSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getUserTimeZoneFail(err));
          reject(err);
        });
    });
  };
};
